module.exports = __webpack_public_path__ + "img/venueone-fd.6c5b6710.png";